import CommonEdit from "@/components/common/Edit";
import { singleProp } from "@/interface/dataInterface";
import axiosInstance from "@/utils/axiosInstance";
import { FC, useEffect, useState } from "react";
import TaxiClientForm from "./ClientForm";

const ClientEdit: FC<singleProp> = ({prop}) => {
    const [formProp, setFormProp] = useState({
        name: "",
        phone_number: "",
        home_address: ""
    })

    useEffect(() => {
        if (!prop) return;
        const getClient = async () => {
            const {data} = await axiosInstance.get(`/taxi-clients/${prop}`)
            const {name, phone_number, home_address} = data
            setFormProp({name: name || "", phone_number: phone_number || "", home_address: home_address || ""})
        }

        getClient()
    }, [prop])

    return (
        <CommonEdit title={`Edit client #${prop}`} id={prop} resource="taxi-clients" data={formProp}>
            <TaxiClientForm formProp={formProp} setFormProp={setFormProp} />
        </CommonEdit>
    )
}

export default ClientEdit